import type { Lang } from '@/i18n';

/** Locale-specific OG images where assets exist; preview locales share the default. */
const LOCALE_OG: Partial<Record<Lang, string>> = {
  ko: '/og-ko.jpg',
  ja: '/og-ja.jpg',
  th: '/og-th.jpg',
  vi: '/og-vi.jpg',
  id: '/og-id.jpg',
  en: '/og-home.jpg',
  'zh-TW': '/og-zh-tw.jpg',
  'zh-CN': '/og-zh-cn.jpg',
};

const DEFAULT_OG = '/og-home.jpg';

export const getOgImage = (lang: Lang): string => LOCALE_OG[lang] ?? DEFAULT_OG;
